import routes from 'router';
import { useRoutes } from 'react-router-dom';
import { Navbar } from 'components/nav';
import { useDocTitle } from 'hooks';
import css from './App.module.scss';

export const App = () => {
  useDocTitle();
  const content = useRoutes(routes);

  return (
    <div className={css.app}>
      <Navbar />
      {content}
    </div>
  );
};
